import Footer from './components/Footer';
import './App.css';
import Hero from './components/Hero.js'

function App() {
  return (
    <div className="App">
      <Hero />
    <Footer />
    </div>
  );
}

export default App;
